module.exports = "<div class=\"m-grid__item m-grid__item--fluid  m-grid m-grid--ver\tm-container m-container--responsive m-container--xxl m-page__container\">\n\t<app-aside-nav></app-aside-nav>\n\t<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/node/src/app/theme/pages/default/default.component.html
// module id = ../../../../../src/app/theme/pages/default/default.component.html
// module chunks = main